import { Injectable } from '@angular/core';
import { LoggingService } from '../logging-service/logging.service';
import { UserSessionService } from '../user-session-service/user-session.service';
import { TrustDataService } from '../trust-data-service/trust-data.service';
import { MatSnackBar } from '../../../../node_modules/@angular/material';
import { map } from 'rxjs/operators/map';
import { AppConfigService } from '../app-config-service/app-config.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { HomeCardModel } from '../../models/home-card-model';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class HomeCardService {

  private trustCardSubscription: Subscription;
  public cardsReady: Subject<boolean> = new Subject<boolean>();

  constructor(public loggingService: LoggingService, public userSession: UserSessionService,
    public snackBar: MatSnackBar, public trustDataService: TrustDataService,
    public appConfig: AppConfigService) { }


  public loadHomeCards() {

    this.trustCardSubscription = this.trustDataService.getAllTrustCards()
      .pipe(map(response => response.json()))
      .subscribe(response => {

        this.loggingService.log('Loading cards', this.appConfig.LogToConsole);
        this.userSession.homeCards = response;
        this.cardsReady.next(true);
        console.log(this.userSession.homeCards);

      }, (error => {
        this.handleError(error);
      }));

    return;
  }

  private handleError(error: HttpErrorResponse) {
    switch (error.status) {
      case 0:
        this.snackBar.open('Sorry, we can\'t do that. You appear to be offline.', '', { duration: 5000 });
        this.loggingService.log('Error - offline', this.appConfig.LogToConsole);
        break;
      case 401:
        this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
        this.loggingService.log('Error - login expired', this.appConfig.LogToConsole);
        break;
      case 500:
        this.snackBar.open('Sorry, we can\'t do that. Server error.', '', { duration: 5000 });
        this.loggingService.log('Error - Server error', this.appConfig.LogToConsole);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/home-card-service/home-card.service.ts